import LuAgencyDivision from './LuAgencyDivision'
import TrackedBill from './TrackedBill'
export default class TrackedBillDivision {
  constructor(objIn = {}) {
    const defaults = {
      //Id is required
      Id: 0,
      //TrackedBillId is required
      TrackedBillId: 0,
      //DivisionId is required
      DivisionId: 0,
    }
    let obj = {}
    Object.assign(obj, defaults, objIn)
    this.Id = obj.Id
    this.TrackedBillId = obj.TrackedBillId
    this.DivisionId = obj.DivisionId
    this.Division = new LuAgencyDivision(obj.Division || {})
    this.TrackedBill = new TrackedBill(obj.TrackedBill || {})
  }
  removeRelated() {
    let obj = Object.assign({}, this)
    obj.Division = null
    obj.TrackedBill = null
    return obj
  }
  root() {
    let obj = Object.assign({}, this)
    obj.Division = null
    obj.TrackedBill = null
    return obj
  }
}
